exhibitionHandler = {
    $panelExhibitionImg: $('.panel-exhibition-image'),
    
    init: function() {
        var self = this;

        self.$panelExhibitionImg.each(function() {
            $panel = $(this);
            $panel.find('.content-item a').on('click', function(e) {
                $('.lightbox-carousel-reveal').data('selected-index', $(this).parent().index() - 1);
                // $carouselImages.flickity('select', $(this).parent().index() - 1);
                // $panel.find('.carousel-container').addClass('is-show');
            });
        });

    }
}